import FaqPage from 'components/Faq/FaqPage';
import { getFaqsCategorized } from 'adapters/albumAdapter';

export const getStaticProps = async () => {
  const faqs = await getFaqsCategorized();
  return {
    props: { faqs }
  };
};

export default FaqPage;
